/**
 * Created with IntelliJ IDEA.
 * User: danielr
 * Date: 5/9/13
 * Time: 9:17 AM
 * To change this template use File | Settings | File Templates.
 *
 * The view for the Categories
 */
define(function (require) {
    "use strict";

    var Marionette = require('marionette');
    var Logger = require('logger');
    var template = require('ui/single-select/templates/singleSelectCategories.tmpl');
    var BaseCollection = require("collections/BaseCollection");
    var SingleSelectItemsView = require("ui/single-select/js/views/SingleSelectItemsView");
    var SelectableCollectionDecorator = require("decorators/SelectableCollectionDecorator");

    var SingleSelectCategoriesView = Marionette.CompositeView.extend({
        template:template,
        itemView: SingleSelectItemsView,
        itemViewContainer: ".items",

        initialize:function (options) {
            this.logger = Logger.getLogger('SingleSelect');
            this.collection = this.model.get("items");
            this.vent = options.vent;

            this.itemViewOptions = {};
            this.itemViewOptions.vent = this.vent;
            this.itemViewOptions.selectedItems = options.selectedItems;
        },

        onRender:function () {

        }
    });

    return SingleSelectCategoriesView;
});

